import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowForward as ArrowForwardIcon } from '@mui/icons-material';

export interface ExpertiseExplorerItem {
  id: string;
  title: string;
  image: string;
  imageAlt: string;
  href: string;
}

interface ExpertiseCardProps {
  expertise: ExpertiseExplorerItem;
  className?: string;
}

const ExpertiseCard: React.FC<ExpertiseCardProps> = ({
  expertise,
  className = '',
}) => {
  return (
    <article className={`group expertise-card h-full ${className}`}>
      <Link
        to={expertise.href}
        className="relative block h-full overflow-hidden rounded-2xl motion-card focus:outline-none focus-visible:ring-2 focus-visible:ring-neutral-900/20 focus-visible:ring-offset-2 motion-safe:hover:-translate-y-0.5"
      >
        <div className="relative aspect-[4/3] w-full overflow-hidden bg-neutral-900 md:aspect-[3/2]">
          <img
            src={expertise.image}
            alt={expertise.imageAlt}
            className="absolute inset-0 h-full w-full object-cover motion-image-zoom motion-safe:group-hover:scale-[1.04]"
            loading="lazy"
            decoding="async"
          />
          <div
            className="image-overlay-card__scrim absolute inset-x-0 bottom-0 h-[58%] bg-gradient-to-t from-black/90 via-black/55 to-transparent"
            aria-hidden
          />
          <div className="absolute inset-x-0 bottom-0 flex items-end justify-between gap-4 p-6 sm:p-7 md:p-8">
            <h3 className="image-overlay-card__title text-xl tracking-tight sm:text-2xl md:text-[1.65rem]">
              {expertise.title}
              <span aria-hidden>.</span>
            </h3>
            <span
              className="image-overlay-card__action flex h-11 w-11 shrink-0 items-center justify-center rounded-full bg-black/40 text-white backdrop-blur-[2px] transition-colors duration-300 group-hover:bg-orange-500/75"
              aria-hidden
            >
              <ArrowForwardIcon className="h-[18px] w-[18px]" />
            </span>
          </div>
        </div>
      </Link>
    </article>
  );
};

export default ExpertiseCard;
